import { render, staticRenderFns } from "./ProductAmount.vue?vue&type=template&id=6d2e01f7&scoped=true"
import script from "./ProductAmount.vue?vue&type=script&lang=js"
export * from "./ProductAmount.vue?vue&type=script&lang=js"
import style0 from "./ProductAmount.vue?vue&type=style&index=0&id=6d2e01f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2e01f7",
  null
  
)

export default component.exports